// apps/admin-panel/src/app/app.routes.ts
import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { restaurantGuard } from './core/guards/restaurant.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
    { path: 'auth', loadComponent: () => import('./features/auth/auth-form.component').then(m => m.AuthFormComponent) },

    // NUEVA RUTA: Registration/Setup fuera del Layout Admin para el "Wizard"
    {
        path: 'setup',
        canActivate: [authGuard],
        loadComponent: () => import('./features/restaurant-setup/restaurant-registration/restaurant-registration.component').then(m => m.RestaurantRegistrationComponent)
    },

    {
        path: 'admin',
        canActivate: [authGuard], // Todos los hijos requieren login
        loadComponent: () => import('./layout/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
        children: [
            {
                path: 'dashboard',
                canActivate: [roleGuard], // Solo comerciales
                loadComponent: () => import('./features/comercial-dashboard/comercial-dashboard.component').then(m => m.ComercialDashboardComponent)
            },
            {
                path: 'menu',
                canActivate: [restaurantGuard], // Requiere tener un restaurante
                loadComponent: () => import('./features/menu-management/restaurant-menu/restaurant-menu.component').then(m => m.RestaurantMenuComponent)
            },
            { path: '', redirectTo: 'menu', pathMatch: 'full' }
        ]
    },
    { path: '', redirectTo: 'admin', pathMatch: 'full' }
];